<template>
    <!-- 采用左右布局 -->
    <el-container class="ht100">
        <!-- 左侧侧边栏 -->
        <el-aside :style="subNavDynamicStyle" class="subnav qcBase">
            <div class="subNav_Titles">
                <h3>质检</h3>
            </div>
            <!-- 侧边导航栏选项 -->
            <el-menu
                    style="border-right: none;margin-top: 70px;"
                    :default-active="menuIndexText($route.path,$route.query)"
                    router
            >
                <el-submenu index="1" v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101000')">
                    <template slot="title">业务建模</template>
                    <el-menu-item index="/qc/newModel/newModel_menu" v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101300')">新建模型</el-menu-item>
                    <el-menu-item index="/qc/businessModeling/modelManagement" v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101400')">模型管理</el-menu-item>
                </el-submenu>
                <el-submenu index="2" v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '102000')">
                    <template slot="title">业务管理</template>
                    <!--<el-menu-item index="/qc/serviceManage/qcTask">质检任务</el-menu-item>
                    <el-menu-item index="/qc/qcPlan">质检方案</el-menu-item>-->
                    <el-menu-item index="/qc/serviceManage/semanticManagement" v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '102100')">语义管理</el-menu-item>
                    <el-menu-item index="/qc/serviceManage/behaviorSettings" v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '102200')">行为设置</el-menu-item>
                </el-submenu>
                <!--<el-menu-item index="/qc/qcReview" v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '102000')">
                  <span slot="title">质检复核</span>
                </el-menu-item>-->
                <el-submenu index="3" v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '103000')">
                    <template slot="title">分析报表</template>
                   <!-- <el-menu-item index="/qc/analysisReport/qcDetailReport">质检明细报表</el-menu-item>-->
                    <el-menu-item index="/qc/analysisReport/qcRealTimeReport" v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '103100')">实时质检报表</el-menu-item>
                    <!--<el-menu-item index="/qc/analysisReport/qcReport">质检报告</el-menu-item>-->
                </el-submenu>
            </el-menu>
        </el-aside>

        <!-- 导航栏收缩小按钮 -->
        <div
                class="icon-sub-shrink"
                :style="iconDynamicStyle"
                @click="clickIconSubShrink()"
        >
            <svg class="icon" aria-hidden="true" :style="iconRotateDynamicStyle">
                <use xlink:href="#iconretract-arrow" />
            </svg>
        </div>

        <!-- 右侧主体面板:通过动态路由加载 -->
        <el-main class="crm-client">
            <router-view></router-view>
        </el-main>
        <MessageComponent/>
        <MessageBoxComponent/>
    </el-container>
</template>
<script>
import MessageComponent from '@/views/qc/public/MessageComponent'
import MessageBoxComponent from '@/views/qc/public/MessageBoxComponent'
import qcAuthUtis from '@/views/qc/utils/authUtis'
import Vue from 'vue'
Vue.prototype.$qcAuthUtis = qcAuthUtis

export default {
  components: {
    MessageComponent,
    MessageBoxComponent
  },
  data() {
    return {
      msg: '系统管理',
      // 导航栏收缩涉及的动态样式
      shrinkSubNav: true,
      subNavDynamicStyle: {
        width: '170px',
        height: '100%',
        display: 'block',
        background: '#f7f8fa',
        'border-right': '1px solid #e1e3e6'
      },
      iconDynamicStyle: { left: '149px' },
      iconRotateDynamicStyle: { transform: 'rotate(0deg)' }
    }
  },
  methods: {
    // 菜单Index高亮特殊处理
    menuIndexText(index, query) {
      if (index === '/qc/newModel/newModel_semanticsModule' && !!(query) && !!(query.id)) {
        return '/qc/businessModeling/modelManagement'
      } else if (index === '/qc/newModel/newModel_semanticsModule' && (!(query) || !(query.id))) {
        return '/qc/newModel/newModel_menu'
      } else if (index === '/qc/newModel/newModel_behaviorModule' && !!(query) && !!(query.id)) {
        return '/qc/businessModeling/modelManagement'
      } else if (index === '/qc/newModel/newModel_behaviorModule' && (!(query) || !(query.id))) {
        return '/qc/newModel/newModel_menu'
      } else {
        return index
      }
    },
    // 收缩或展开侧边导航栏
    clickIconSubShrink() {
      if (this.shrinkSubNav) {
        this.subNavDynamicStyle = { display: 'none' }
        this.iconDynamicStyle = { left: '0px' }
        this.iconRotateDynamicStyle = { transform: 'rotate(180deg)' }
        this.shrinkSubNav = false
      } else {
        this.subNavDynamicStyle = {
          width: '170px',
          height: '100%',
          display: 'block',
          background: '#f7f8fa',
          'border-right': '1px solid #e1e3e6'
        }
        this.iconDynamicStyle = { left: '149px' }
        this.iconRotateDynamicStyle = { transform: 'rotate(0deg)' }
        this.shrinkSubNav = true
      }
    }
  }
}
</script>
<style>
    .el-popover-qc {
        background: #fcf8e3!important;
        border:#f7dea9 solid 1px !important;
        font-size: 12px;
    }
    .el-popover-qc .popper__arrow{
        border-top-color: #f7dea9!important;
    }
    .el-popover-qc .popper__arrow:after{
        border-top-color: #fcf8e3!important;
    }
    .el-table-filter>.el-table-filter__bottom {
        text-align: center;
    }
</style>
<style lang='scss' scoped>
    .crm-client{
        /* 设置滚动槽样式 */
        ::-webkit-scrollbar {
            width: 4px;
            background-color: #fff;
        }
        ::-webkit-scrollbar-track {
            border-radius: 4px;
        }
        ::-webkit-scrollbar-thumb {
            background-color: #eee;
        }
        .el-dialog {
            border-radius: 10px;
            .el-dialog__header {
                text-align: left;
                padding-top:10px;
                line-height: 25px !important;
                border-bottom: 1px solid #eee;
                .el-dialog__title {
                    font-size: 14px !important;
                }
                .el-dialog__headerbtn {
                    top:15px;
                    .el-dialog__close{
                        font-weight: 700;
                    }
                }
            }
        }
        .el-table td{
            height: 65px !important;
        }
        .el-table tbody tr:hover>td {
            background-color:#fafafa!important
        }
    }
    // table提示框的背景颜色修改
    .el-tooltip__popper.is-dark {
        background: #fff;
        color: #666666;
        border: 1px solid #ccc;
        // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    }
    .el-tooltip__popper .popper__arrow, .el-tooltip__popper .popper__arrow::after{
        display: none;
    }
    .el-popover{
        min-width: 125px;
    }

    .el-submenu__title{
        background-color: #f7f8fa;
        color: #555555;
    }
    .el-submenu__title:hover {
        background-color: #f7f8fa;
        color: #337eff;
    }
    .el-submenu__title i{
        font-size: 14px;
        font-weight: 700;
    }
    .el-submenu__title:hover i{
        color: #337eff;
    }
</style>
<style scoped>
    .subNav_Title {
        position: relative;
        height: 70px;
        line-height: 70px;
        padding: 0 20px;
        border-bottom: 1px solid #e1e3e6;
        color: #222222;
        border-bottom: 1px solid #e1e3e6;
    }
    .subNav_Titles {
        position: relative;
        height: 70px;
        line-height: 70px;
        padding: 0 20px;
        border-bottom: 1px solid #e1e3e6;
        color: #222222;
        border-bottom: 1px solid #e1e3e6;
        position: absolute;
        z-index: 1;
        width: 169px;
        background: #f7f8fa;
    }
    .el-submenu .el-menu-item{
        min-width: 160px !important;
        height: 42px;
        line-height: 42px;
    }
    .qcBase {
        overflow-x: hidden;
    }
    .qcBase::-webkit-scrollbar {
        width: 0px;
    }
    .qcBase::-webkit-scrollbar {
        width: 0px;
    }
    .qcBase::-webkit-scrollbar-track {
        background-color:#fff;
        -webkit-border-radius: 1px;
        -moz-border-radius: 1px;
        border-radius:1px;
    }
    .qcBase::-webkit-scrollbar-thumb {
        background-color:#ddd;
        -webkit-border-radius: 1px;
        -moz-border-radius: 1px;
        border-radius:1px;
        border-radius:10px;
    }
</style>
